import React, { useState, useEffect } from "react";
import AdminMenu from "../../components/Layout/AdminMenu";
import Layout from "./../../components/Layout/Layout";
import axios from "axios";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import "../../styles/Admin-User-panel.css";

const Products = () => {
  const [products, setProducts] = useState([]);

  //getall products
  const getAllProducts = async () => {
    try {
      const { data } = await axios.get(`https://avon.onrender.com/api/v1/product/get-product`);
      setProducts(data.products);
    } catch (error) {
      console.log(error);
      toast.error("Someething Went Wrong");
    }
  };


  //lifecycle method
  useEffect(() => {
    getAllProducts();
  }, []);

    // refetch products whenever the products state changes
    useEffect(() => {
      getAllProducts();
    }, [products]);


  return (
    <Layout>
    <div className="sidebar-container-pro">
      <div className="col-md-3">
        <AdminMenu />
      </div>
      <div className="col-md-4">
        <h1 className="text-center">All Products List</h1>
        <div className="d-flex-pro flex-wrap">
          {products?.map((p) => (
            <Link
              key={p._id}
              to={`/dashboard/admin/product/${p.slug}`}
              className="product-link"
            >
              <div className="card m-2" style={{ width: "18rem" }}>
                <img
                  src={`https://avon.onrender.com/api/v1/product/product-photo/${p._id}`}
                  className="card-img-top-pro"
                  alt={p.name}
                />
                <div className="card-body-pro">
                  <h5 className="card-title">{p.name}</h5>
                  <p className="card-text">{p.description}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  </Layout>
  );
};

export default Products;